import React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import PetsIcon from '@mui/icons-material/Pets';
import PregnantWomanIcon from '@mui/icons-material/PregnantWoman';
import ChildFriendlyIcon from '@mui/icons-material/ChildFriendly';

import pink from '@mui/material/colors/pink';
import lightBlue from '@mui/material/colors/lightBlue';
import lightGreen from '@mui/material/colors/lightGreen';

import AddCrature from './AddCrature';
import Zoom from '@mui/material/Zoom';
import Collapse from '@mui/material/Collapse';
import {
    addEntityToState,
    addCreature,
    addCreatureNachzucht,
    removeEntityFromState
} from '../Actions';
import Creature from './Creature';

const style = {
  cardParent: {
    marginBottom:"15px",
    //padding:"10px 20px 10px 20px",
    //backgroundColor:"#f6f6f6",
  },
  cardActions: {
    //paddingLeft:"8px",
  },
  paperChild: {
    marginBottom:"30px",
    padding:"10px 20px 10px 20px",
  },
  groupChild: {
    marginBottom:"-16px",
    marginLeft:"-16px",
    marginRight:"-16px",
    padding:"8px 16px 16px 16px",
    position:"relative",
    borderTop: "1px solid #e0e0e0",
    borderLeft: "5px solid #ff98bb",
    //backgroundColor:"#FFF6F6",
  },
  standardAvatar: {
    backgroundColor:lightGreen[500],
  },
  standardTitle: {
    color:lightGreen[500],
  },
  parentAvatar: {
    backgroundColor:lightBlue[500],
  },
  parentTitle: {
    color:lightBlue[500],
  },
  childAvatar: {
    backgroundColor:pink[500],
  },
  childTitle: {
    color:pink[500],
  },
}
  
const Creatures = (props) => {

  return (
    <div>
        {Object.keys(props.creatures).map(
            (uniqueId) => {
              if (props.creatures[uniqueId].type == "litter") {
                let parents = []
                let children = []
                Object.keys(props.creatures[uniqueId].parents).map(
                  (uniqueIdParent, index) => {
                    let pathParents = ['creatures', uniqueId, 'parents', uniqueIdParent]
                    parents.push(CreatureInLitter(props.creatures[uniqueId].parents[uniqueIdParent], props.dispatch, props.restLadeSpezies, pathParents, props))
                  }
                )
                Object.keys(props.creatures[uniqueId].children).map(
                  (uniqueIdChild) => {
                    let pathChildren = ['creatures', uniqueId, 'children', uniqueIdChild]
                    children.push(CreatureInLitter(props.creatures[uniqueId].children[uniqueIdChild], props.dispatch, props.restLadeSpezies, pathChildren, props))
                  }
                ) 

                return (
                  <Card style={style.cardParent} key={uniqueId+"-litter"}>
                    <CardHeader
                      action={
                        <IconButton sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}} 
                          aria-label="Nachzuchtgruppe löschen"
                          disabled={Object.keys(props.creatures).length > 1 ? false : true}
                          onClick={
                            ()=> {
                              if (!confirm("Wollen Sie die Nachzuchtgruppe (Wurf) wirklich löschen? Eingegebene Daten gehen verloren!")) {
                                return;
                              }
                                
                              props.dispatch(
                                removeEntityFromState('creatures.'+uniqueId)
                              )

                            }
                          }
                        >
                          <ClearIcon />
                        </IconButton>

                      }
                      title="Nachzucht"
                    />
                    <CardContent>
                      <h2>Elterntiere</h2>
                      {parents}
                    </CardContent>
                    <CardActions>
                      <AddCrature
                        plus={
                          ()=>{
                            let crtr = props.creatureParent()
                            props.dispatch(
                              addCreatureNachzucht(
                                crtr,
                                'creatures.'+uniqueId+'.parents.'+crtr.uniqueId
                              )
                            )
                          }
                        }
                        anzahlCreatures={Object.keys(props.creatures).length}
                        addLabel="Elterntier hinzufügen"
                      />
                    </CardActions>
                    <CardContent>
                      <h2>Nachkommen</h2>
                      {children}
                    </CardContent>
                    <CardActions>
                      <AddCrature
                        plus={
                          ()=>{
                            let crtr = props.creatureChild()
                            props.dispatch(
                              addCreatureNachzucht(
                                crtr,
                                'creatures.'+uniqueId+'.children.'+crtr.uniqueId
                                
                              )                            )
                          }
                        }
                        anzahlCreatures={Object.keys(props.creatures).length}
                        addLabel="Nachkommen hinzufügen"
                      />
                    </CardActions>
                  </Card>
                );
              } else {
                return SingleCreature(props.creatures[uniqueId], props.dispatch, props.restLadeSpezies, props);
              }
            }
        )}
        <div style={{textAlign:"center"}}>
          {props.creatureExemplar && !props.weitereExemplareUnterbinden &&
            <p>
            <AddCrature
              plus={
                ()=>{
                  let crtr = props.creatureExemplar()
                  props.dispatch(
                    addCreature(
                      crtr,
                      ["creatures"]
                    )
                  )
                }
              }
              anzahlCreatures={Object.keys(props.creatures).length}
              addLabel="Exemplar hinzufügen"
            />
            </p>
          }
          {props.creatureParent &&
            <p>
            <AddCrature
              plus={
                ()=>{
                  props.addLitter()
                }
              }
              addLabel="Nachzuchten (Elterntiere und Nachkommen) hinzufügen"
            />
            </p>
          }
        </div>

    </div>
  )
}

const SingleCreature = (creature, dispatch, restLadeSpezies, props) => {

  return (
    <Zoom 
      in={true} 
      style={{ transitionDelay: '10ms' }}
      key={creature.uniqueId}
    >
      <Card style={style.cardParent}>
        <CardHeader
          avatar={avatar(creature.role)}
          action={
            <div>
            <IconButton sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}} 
              aria-label="Exemplar löschen"
              onClick={
                ()=> {
                  props.updaterValue('creatures.'+creature.uniqueId)("zoomIn")(!creature.zoomIn.value)
                }
              }
            >
              {
                creature.zoomIn.value
                ?<ExpandLessIcon />
                :<ExpandMoreIcon />
              }
            </IconButton>
            <IconButton sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}} 
              aria-label="Exemplar löschen"
              onClick={
                ()=> {
                  if (!confirm("Wollen Sie das Exemplar wirklich löschen? Eingegebene Daten gehen verloren!")) {
                    return;
                  }
                    
                  props.dispatch(
                    removeEntityFromState('creatures.'+creature.uniqueId)
                  )

                }
              }
            >
              <ClearIcon />
            </IconButton>
            </div>
          }
          title={title(creature)}
        />
        <Collapse in={creature.zoomIn.value}>
          <CardContent>
            <Creature
              creature={creature}
              externeAnzahl={props.externeAnzahl}
              dispatch={dispatch}
              updaterValue={props.updaterValue('creatures.'+creature.uniqueId)}
              updaterTouch={props.updaterTouch('creatures.'+creature.uniqueId)}
              updaterValid={props.updaterValid('creatures.'+creature.uniqueId)}
              restLadeSpezies={restLadeSpezies}
              restPath={props.restPath}
              creaturePath={['creatures', creature.uniqueId]}
              addEntity={addEntity(dispatch, 'creatures.'+creature.uniqueId)}
              removeEntity={removeEntity(dispatch, 'creatures.'+creature.uniqueId)}
              konfigurationKreatur = {props.konfiguration.importierteKonfiguration.kreatur}
              sonderfall = {props.sonderfall}
            />
          </CardContent>
        </Collapse>
      </Card>
    </Zoom>
  );
}

const CreatureInLitter = (creature, dispatch, restLadeSpezies, path, props) => {
  let pathString = path.join('.')
  return (
    <Zoom 
      in={true} 
      style={{ transitionDelay: '10ms' }}
      key={creature.uniqueId+"-zoom"}
    >

      <div style={style.groupChild}>
        <CardHeader
          style={{padding:"0px"}}
          avatar={avatar(creature.role)}
          action={
            <IconButton sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}} 
              aria-label="Nachkommen löschen"
              onClick={
                ()=> {
                  props.dispatch(
                    removeEntityFromState(path)
                  )
                }
              }
            >
              <ClearIcon />
            </IconButton>
          }
          title={title(creature)}
        />
        <Creature
          creature={creature}
          externeAnzahl={props.externeAnzahl}
          dispatch={dispatch}
          updaterValue={props.updaterValue(pathString)}
          updaterTouch={props.updaterTouch(pathString)}
          updaterValid={props.updaterValid(pathString)}
          restLadeSpezies={restLadeSpezies}
          restPath={props.restPath}
          creaturePath={path}
          lineage={path}
          addEntity={addEntity(dispatch, pathString)}
          removeEntity={removeEntity(dispatch, pathString)}
          konfigurationKreatur = {props.konfiguration.importierteKonfiguration.kreatur}
          meldenummerAnzeigename={props.konfiguration.importierteKonfiguration.kreatur.meldenummer_angezeigter_Name}
        />
      </div>
      
    </Zoom>
  );
}

const addEntity = (dispatch, path) => (name,entity) => {
  dispatch(
      addEntityToState(
        path+"."+name,
        entity
      )
  )
}

const removeEntity = (dispatch, path) => (name) => {
  dispatch(
      removeEntityFromState(
        path+"."+name
      )
  )
}

const title = (creature) => {
  let styler = style.standardTitle
  
  let text = "Exemplar"
  if (creature.anzahl > 1) {
    text = creature.anzahl + " Exemplare"
  }

  if (creature.role == "parent") {
    styler = style.parentTitle
    text = "Elterntier"
  }

  if (creature.role == "child") {
    styler = style.childTitle
    text = "Nachkommen"
    if (creature.anzahl > 1) {
      text = creature.anzahl + " Nachkommen"
    }
  }

  if (creature.hasOwnProperty("rufname") && creature.rufname.value) {
    text = creature.rufname.value
  }

  return (
    <h2 style={styler}>{text}</h2>
  );
}

const avatar = (role) => {
  if (role == "parent") {
    return (
      <Avatar aria-label="Exemplar" style={style.parentAvatar}>
        <PregnantWomanIcon />
      </Avatar>
    );
  }

  if (role == "child") {
    return (
      <Avatar aria-label="Exemplar" style={style.childAvatar}>
        <ChildFriendlyIcon />
      </Avatar>
    );
  }

  return (
    <Avatar aria-label="Exemplar" style={style.standardAvatar}>
      <PetsIcon />
    </Avatar>
  );
}

export default Creatures;